import { getPatientBookAPI } from "../adapter/cms-adapter";

export const getPatientBook = (data) => {

    let reqData = {
        hospital_id: 1
    }

    let promise = new Promise(function (resolve, reject) {

        getPatientBookAPI(reqData).then((res) => {

            console.log("patient book rs: ", res);
            if (res && res.data) resolve(res.data);

            else reject("some error message getHospitalDetails");
        })
    })

    return promise;
}